$(function () {
  document.addEventListener("click", function (e) {
    const link = e.target.closest("a.track-image");
    const href = link.href;
    const target = link.getAttribute('target');
    if (!link) return;

    e.preventDefault();

    const data = {
      ad_id: link.dataset.adId,
      action: 'modify_advertisement_counter'
    };

    $.ajax({
      url: ajaxurl,
      type: 'POST',
      data: data,
    }).always(function () {
      if (target === '_blank') {
        window.open(href, '_blank');
      } else {
        window.location.href = href;
      }
    });
  });

  let player;
  let firstPlayDone = false;

  function onYouTubeIframeAPIReady() {
    player = new YT.Player('yt-player', {
      events: {
        onStateChange: onPlayerStateChange
      }
    });
  }

  if (typeof YT !== 'undefined' && YT && YT.Player) {
    player = new YT.Player('yt-player', { events: { onStateChange: onPlayerStateChange } });
  }

  function onPlayerStateChange(event) {
    if (event.data === YT.PlayerState.PLAYING && !firstPlayDone) {
      firstPlayDone = true;

      const adDiv = document.querySelector('.advertisement');
      const adId = adDiv.dataset.adId;
      if (!adId) return;

      const data = {
        ad_id: adId,
        action: 'modify_advertisement_counter'
      };

      $.ajax({
        url: ajaxurl,
        type: 'POST',
        data: data,
      });
    }
  }


  function initPlayer() {
    const iframe = document.querySelector('iframe.vimeo-embed');
    if (!iframe) return;

    const player = new Vimeo.Player(iframe);
    player.ready().then(() => {
      let firstPlayDone = false;
      player.on('play', () => {
        if (!firstPlayDone) {
          firstPlayDone = true;

          const adDiv = document.querySelector('.advertisement');
          const adId = adDiv.dataset.adId;
          if (!adId) return;

          const data = {
            ad_id: adId,
            action: 'modify_advertisement_counter'
          };

          $.ajax({
            url: ajaxurl,
            type: 'POST',
            data: data,
          });
        }
      });
    });
  }

// Jeśli DOM już jest gotowy, od razu wywołaj
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPlayer);
  } else {
    initPlayer();
  }


});